// 校验语言包
export default {
  'zh-CN': {
    pattern: '该字段不是一个合法的字段',
    required: '该字段是必填字段',
    number: '该字段不是合法的数字',
    integer: '该字段不是合法的整型数字',
    url: '该字段不是合法的url',
    email: '该字段不是合法的邮箱格式',
    ipv6: '该字段不是合法的ipv6格式',
    ipv4: '该字段不是合法的ipv4格式',
    idcard: '该字段不是合法的身份证格式',
    taodomain: '该字段不符合淘系域名规则',
    qq: '该字段不符合QQ号格式',
    phone: '该字段不是有效的手机号',
    money: '该字段不是有效货币格式',
    zh: '该字段不是合法的中文字符串',
    date: '该字段不是合法的日期格式',
    zip: '该字段不是合法的邮编格式',
    len: '长度或条目数必须为{{len}}',
    min: '长度或条目数不能小于{{min}}',
    max: '长度或条目数不能大于{{max}}',
    maximum: '数值不能大于{{maximum}}',
    exclusiveMaximum: '数值必须小于{{exclusiveMaximum}}',
    minimum: '数值不能小于{{minimum}}',
    exclusiveMinimum: '数值必须大于{{exclusiveMinimum}}',
    whitespace: '不能为纯空白字符串',
  },
  'es-MX': {
    // 西语
    pattern: 'Este campo no es un campo legal',
    required: 'Este campo es obligatorio',
    number: 'Este campo no es un número legal',
    integer: 'Este campo no es un número entero legal',
    url: 'Este campo no es una url legítima',
    email: 'Este campo no es un formato de correo electrónico legítimo',
    ipv6: 'Este campo no está en formato ipv6 legítimo',
    ipv4: 'Este campo no está en formato ipv4 legítimo',
    idcard: 'Este campo no es un formato de identificación legal',
    taodomain: 'Este campo no cumple con las reglas de nombres de dominio',
    qq: 'Este campo no cumple con el formato del número QQ',
    phone: 'Este campo no es un número de teléfono válido',
    money: 'Este campo no es un formato de moneda válido',
    zh: 'Este campo no es una cadena China legítima',
    date: 'Este campo no es un formato de fecha legal',
    zip: 'Este campo no tiene un formato de código postal legal',
    len: 'La longitud o el número de entradas debe ser{{len}}',
    min: 'La longitud o el número de entradas no puede ser menor que{{min}}',
    max: 'La longitud o el número de entradas no puede ser mayor que{{max}}',
    maximum: 'El valor no puede ser mayor que{{maximum}}',
    exclusiveMaximum: 'El valor debe ser menor que{{exclusiveMaximum}}',
    minimum: 'El valor no debe ser menor que{{minimum}}',
    exclusiveMinimum: 'El valor debe ser mayor que{{exclusiveMinimum}}',
    whitespace: 'No puede ser una cadena en blanco pura',
  },
  'pt-BR': {
    // 葡语
    pattern: 'Este campo não é um campo legal',
    required: 'Este campo é obrigatório',
    number: 'Este campo não é um número legítimo',
    integer: 'Este campo não é um número inteiro legal',
    url: 'Este campo não é um url legítimo',
    email: 'Este campo não é um formato de caixa de correio legítimo',
    ipv6: 'Este campo não está no formato ipv6 legítimo',
    ipv4: 'Este campo não está no formato ipv4 legítimo',
    idcard: 'Este campo não é um formato de identificação legal',
    taodomain: 'Este campo não cumpre as regras de nomes de domínio',
    qq: 'Este campo não corresponde ao formato do número QQ',
    phone: 'Este campo não é um número de telemóvel válido',
    money: 'Este campo não é um formato de moeda válido',
    zh: 'Este campo não é uma string chinesa legítima',
    date: 'Este campo não é um formato de data legal',
    zip: 'Este campo não tem um formato de código postal legítimo',
    len: 'O comprimento ou número de entradas deve ser{{len}}',
    min: 'Comprimento ou número de entradas não pode ser menor que{{min}}',
    max: 'Comprimento ou número de entradas não pode ser maior do que{{max}}',
    maximum: 'O valor não pode ser maior que{{maximum}}',
    exclusiveMaximum: 'O valor deve ser menor que{{exclusiveMaximum}}',
    minimum: 'O valor não pode ser menor que{{minimum}}',
    exclusiveMinimum: 'O valor deve ser maior que{{exclusiveMinimum}}',
    whitespace: 'Não pode ser uma string em branco pura',
  },
};
